import type { Patient } from "fhir/r5";
import {
  getPatientCpf,
  getPatientDisplayName,
  getPatientEmail,
} from "../transformers/wooFormatters";

export function getEcommercePatientKey(patient: Patient): string {
  return patient.id || getPatientCpf(patient);
}

function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

/** Filtro local (OR): nome, e-mail ou CPF — sem novo request. */
export function matchesPatientSearch(
  patient: Patient,
  rawTerm: string,
): boolean {
  const term = rawTerm.trim().toLowerCase();
  if (!term) return true;

  const name = getPatientDisplayName(patient).toLowerCase();
  const email = getPatientEmail(patient).toLowerCase();
  const cpfDigits = digitsOnly(getPatientCpf(patient));
  const termDigits = digitsOnly(term);

  const matchesName = name.includes(term);
  const matchesEmail = email.includes(term);
  const matchesCpf = termDigits.length > 0 && cpfDigits.includes(termDigits);

  return matchesName || matchesEmail || matchesCpf;
}
